export const googlePlayStore = "https://play.google.com/store/apps/details?id=com.musicatorsnative";
export const appleStore = "https://apps.apple.com/us/app/musicators/id1578165674";
